module.exports = __webpack_public_path__ + "img/SBBSceno.e34ba215.png";